export const INITIALIZE_FAMILY_DASHBOARD = 'INITIALIZE_FAMILY_DASHBOARD'

export function initializeFamilyDashboard() {
  return { type: INITIALIZE_FAMILY_DASHBOARD }
}
